import { c as _c } from "react/compiler-runtime";
import { NavigationLink } from '@/components/Atoms/NavigationLink/NavigationLink';
import { PageContainer } from '@/components/Templates/PageContainer/PageContainer';
import useTranslation from '@/hooks/useTranslation';
import { breakpoints } from '@/styles/media';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { Logo } from '../Logo';
export const GuestNavigation = () => {
  const $ = _c(15);
  const {
    t
  } = useTranslation("common");
  const {
    asPath
  } = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StyledLogo />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("Navigation.Guest.notice");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Notice>{t1}</Notice>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/logout?r=${encodeURIComponent(asPath)}`;
  let t4;
  if ($[5] !== t) {
    t4 = t("Navigation.Guest.login");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span>{t4}</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Login href={t3}>{t5}</Login>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <PageContainer><StyledBar>{t0}{t2}{t6}</StyledBar></PageContainer>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const StyledBar = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: var(--size-masthead-innerHeight);
`;
const StyledLogo = styled(Logo)`
    flex: initial;
`;
const Notice = styled.div`
    flex: 1;
    margin-left: var(--size-grid-half);
    color: var(--color-body-accent);
    display: none;
    align-items: center;
    ${breakpoints.S`
        display: flex;
    `}
`;
const Login = styled(NavigationLink)`
    justify-self: flex-end;
`;